module.exports = __webpack_public_path__ + "img/Portafolio Kontakt_3.716ba080.png";